import { get } from 'lodash';

// Constants
import {
    RESET_EMAIL_VERIFICATION,
    SET_EMAIL_VERIFICATION,
    SET_EMAIL_VERIFICATION_STATUS,
    EMAIL_VERIFICATION
} from './email-verification.constants';

// types
import { Dispatch } from 'types/dispatch';
import { IUserDetailInfo } from 'types/profiles';

// services
import { UbisoftAPIService } from 'modules/ubisoft-api';
import emailVerificationService from './email-verification.service';

export const setEmailVerificationStatus = (payload: EMAIL_VERIFICATION) => ({
    type: SET_EMAIL_VERIFICATION_STATUS,
    payload
});

const setEmailVerification = (payload: string) => ({
    type: SET_EMAIL_VERIFICATION,
    payload
});

export const resetEmailVerification = () => ({
    type: RESET_EMAIL_VERIFICATION
});

export const checkEmailVerification = () => (dispatch: Dispatch, getState: Function) => {
    const loginSession = get(getState(), 'login.loginSession');

    if (loginSession) {
        const { UbisoftConnectTicket, UbisoftConnectProfile, sessionId } = loginSession;
        return emailVerificationService
            .isEmailVerified({
                ticket: UbisoftConnectTicket,
                sessionId,
                userId: UbisoftConnectProfile.user.userId
            })
            .then(isEmailVerified => {
                if (!isEmailVerified) {
                    dispatch(setEmailVerificationStatus(EMAIL_VERIFICATION.NOT_COMPLETED));
                } else {
                    dispatch(setEmailVerificationStatus(EMAIL_VERIFICATION.COMPLETED));
                }
            });
    } else {
        return Promise.reject();
    }
};

export const checkIsEmailVerified = () => async (
    _: Dispatch,
    getState: Function
): Promise<boolean> => {
    const loginSession = get(getState(), 'login.loginSession');

    if (!loginSession) {
        return Promise.reject();
    }

    const { UbisoftConnectTicket, UbisoftConnectProfile, sessionId } = loginSession;

    try {
        return await emailVerificationService.isEmailVerified({
            ticket: UbisoftConnectTicket,
            sessionId,
            userId: UbisoftConnectProfile.user.userId
        });
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getVerificationEmail = () => async (dispatch: Dispatch) => {
    try {
        const { email }: IUserDetailInfo = await UbisoftAPIService.getUserInfo();

        return dispatch(setEmailVerification(email));
    } catch (e) {
        return Promise.reject(e);
    }
};

export const verifyEmail = () => (dispatch: Dispatch, getState: Function) => {
    const loginSession = get(getState(), 'login.loginSession');

    if (!loginSession) {
        return Promise.reject();
    }

    const { UbisoftConnectTicket, UbisoftConnectProfile, sessionId } = loginSession;

    dispatch(setEmailVerificationStatus(EMAIL_VERIFICATION.SENDING));

    return emailVerificationService
        .triggerEmailActivation({
            ticket: UbisoftConnectTicket,
            sessionId,
            userId: UbisoftConnectProfile.user.userId
        })
        .then(() => {
            dispatch(setEmailVerificationStatus(EMAIL_VERIFICATION.SENT));
        });
};

export const cancelVerification = () => (dispatch: Dispatch) => {
    dispatch(setEmailVerificationStatus(EMAIL_VERIFICATION.COMPLETED));
};

export type EmailVerificationStatusAction = ReturnType<typeof setEmailVerificationStatus>;
export type Actions = EmailVerificationStatusAction
| ReturnType<typeof resetEmailVerification>
| ReturnType<typeof setEmailVerification>;
